import { MessagesInterface } from '../../../general/model';

export const Messages = {
  createFolderError: () => ({
    title: 'Server request error',
    message: 'Folder has not been created',
  }),
} as MessagesInterface;

export const initialState: NewFolderShape = {
  name: 'New folder',
  isOpen: false,
  inProgress: false,
};

export type NewFolderShape = {
  name: string;
  isOpen: boolean;
  inProgress: boolean;
};
